import { useSelector } from "react-redux";
import { IAppState } from "../../Common";

export const useApps = () => {
  const availableApps = useSelector((state: IAppState) => ({
    loadedApps: state.app.applications,
    appLoadingState: state.app.appsLoadingState
  }));

  return availableApps;
};
